export default {
    experts: null,
    expert: null,
    expertVideos: null,
    videosComingSoonFlag: false,
    expertPlaylist: null,
    expertArchiveClips: null,
    expertNextEvent: null
}



// WEBPACK FOOTER //
// ./src/store/experts/state.js